import axios from 'axios';
import { API_URL } from '../config';

// Create axios instance with base URL
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export interface Permission {
  id: number;
  name: string;
  guard_name: string;
  created_at: string;
  updated_at: string;
}

export interface Role {
  id: number;
  name: string;
  guard_name: string;
  permissions: Permission[];
  created_at: string;
  updated_at: string;
}

export const rolePermissionService = {
  // Roles
  getRoles: () => api.get('/roles'),
  createRole: (data: { name: string; permissions?: number[] }) =>
    api.post('/roles', data),
  updateRole: (id: number, data: { name: string; permissions?: number[] }) =>
    api.put(`/roles/${id}`, data),
  deleteRole: (id: number) => api.delete(`/roles/${id}`),
  getRole: (id: number) => api.get(`/roles/${id}`),

  // Permissions
  getPermissions: () => api.get('/permissions'),
  createPermission: (data: { name: string }) => api.post('/permissions', data),
  updatePermission: (id: number, data: { name: string }) =>
    api.put(`/permissions/${id}`, data),
  deletePermission: (id: number) => api.delete(`/permissions/${id}`),
  getPermission: (id: number) => api.get(`/permissions/${id}`),
};
